var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgScheme1 = function SvgScheme1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    viewBox: "0 0 491.001 491.001",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.3,337.05h-52.1v-93.8c0-11.5-9.4-20.9-20.9-20.9H265.9v-69.9H317c11.5,0,19.8-8.3,20.9-19.8V21.25   c0-11.5-9.4-20.9-20.9-20.9H173.1c-11.5,0-20.9,9.4-20.9,20.9v110.5c0,11.5,9.4,20.9,20.9,20.9h51.1v69.9H91.8   c-11.5,0-20.9,9.4-20.9,20.9v93.8h-50c-11.5,0-20.9,9.4-20.9,20.9v111.6c0,11.5,9.4,20.9,20.9,20.9h142.8   c11.5,0,20.9-9.4,21.9-20.9v-111.8c0-11.5-9.4-20.9-20.9-20.9h-52.1v-74h264.8v74h-51.1c-11.5,0-20.9,9.4-20.9,20.9v111.6   c0,11.5,9.4,20.9,20.9,20.9h142.8c11.5,0,20.9-9.4,21.9-20.9v-111.6C491.1,346.45,481.7,337.05,470.3,337.05z M194,41.05h103.2   v70.9H194V41.05z M144,449.65H40.7v-70.9h103.2v70.9H144z M449.4,449.65H346.2v-70.9h103.2V449.65z",
    fill: "#ffffff",
    style: {},
    className: ""
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScheme1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scheme1.a78d803a.svg";
export { ForwardRef as ReactComponent };